import { Container, Accordion, Card, Badge, Button } from "react-bootstrap";
import { FaLock, FaShieldAlt, FaBalanceScale, FaFileContract, FaQuestionCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next"; // Import useTranslation

function TermsOfService() {
  const { t } = useTranslation(); // Initialize useTranslation hook

  return (
    <Container className="py-5" style={{ maxWidth: "800px" }}>
      {/* Hero Section */}
      <div className="text-center mb-5">
        <h1 className="display-4 mb-3">
          <span className="text-primary">🐨</span> {t("termsOfService.title")}
        </h1>
        <p className="lead">{t("termsOfService.description")}</p>
        <Badge bg="light" text="dark" className="mt-2">
          {t("termsOfService.lastUpdated", { date: new Date().toLocaleDateString() })}
        </Badge>
      </div>

      {/* Main Content */}
      <Card className="shadow-sm border-0 rounded-3">
        <Card.Body className="p-4">
          <Accordion defaultActiveKey="0" flush alwaysOpen>
            {/* Acceptance */}
            <Accordion.Item eventKey="0" className="border-0">
              <Accordion.Header>
                <FaFileContract className="text-primary me-3" />
                <h5 className="mb-0">{t("termsOfService.acceptance.header")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <p>
                  {t("termsOfService.acceptance.body")}
                  <a href="/privacy" className="text-decoration-none">
                    {" "}
                    {t("header.privacy")}
                  </a>
                </p>
              </Accordion.Body>
            </Accordion.Item>

            {/* User Responsibilities */}
            <Accordion.Item eventKey="1" className="border-0">
              <Accordion.Header>
                <FaBalanceScale className="text-primary me-3" />
                <h5 className="mb-0">{t("termsOfService.responsibilities.header")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="list-unstyled">
                  {t("termsOfService.responsibilities.body.list", { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>

            {/* AI Processing */}
            <Accordion.Item eventKey="2" className="border-0">
              <Accordion.Header>
                <FaShieldAlt className="text-primary me-3" />
                <h5 className="mb-0">{t("termsOfService.aiProcessing.header")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <p>{t("termsOfService.aiProcessing.body.intro")}</p>
                <ul>
                  {t("termsOfService.aiProcessing.body.list", { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
                <p className="text-muted">
                  <small>{t("termsOfService.aiProcessing.body.disclaimer")}</small>
                </p>
              </Accordion.Body>
            </Accordion.Item>

            {/* Account Management */}
            <Accordion.Item eventKey="3" className="border-0">
              <Accordion.Header>
                <FaLock className="text-primary me-3" />
                <h5 className="mb-0">{t("termsOfService.accountManagement.header")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <p>{t("termsOfService.accountManagement.body")}</p>
                <div className="alert alert-warning mt-3">
                  <strong>{t("termsOfService.accountManagement.warning.header")}</strong>
                  {t("termsOfService.accountManagement.warning.body")}
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Important Disclaimers */}
            <Accordion.Item eventKey="4" className="border-0">
              <Accordion.Header>
                <FaQuestionCircle className="text-primary me-3" />
                <h5 className="mb-0">{t("termsOfService.disclaimers.header")}</h5>
              </Accordion.Header>
              <Accordion.Body>
                <p>{t("termsOfService.disclaimers.body.intro")}</p>
                <ul>
                  {t("termsOfService.disclaimers.body.list", { returnObjects: true }).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Card.Body>
      </Card>

      {/* Contact Section */}
      <div className="text-center mt-5 p-4 bg-light rounded-3">
        <h5 className="mb-3">{t("termsOfService.contact.header")}</h5>
        <Button variant="primary" href="/contact">
          {t("termsOfService.contact.buttonText")}
        </Button>
        <p className="mt-3 text-muted small">
          {t("termsOfService.contact.email")}
          <br />
          {t("termsOfService.contact.responseTime")}
        </p>
      </div>

      {/* Footer Note */}
      <p className="text-center text-muted mt-5 small">
        {t("termsOfService.footer.compliance")}
        <br />
        {t("termsOfService.footer.dataProcessingAddendum")}
      </p>
    </Container>
  );
}

export default TermsOfService;
